'use client'

import { Image } from '@vinted/web-ui'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { ProofSectionModel } from '../../types'

type Props = { props: ProofSectionModel }

const ProofSection = ({ props }: Props) => {
  const { text, image, testId } = props
  const translate = useTranslate()
  const isFSEnabled = useFeatureSwitch('web_dac7_proof_section')

  if (!isFSEnabled) return null

  return (
    <section className="secondhand-taxes__proof-section" data-testid={testId}>
      <h2 className="secondhand-taxes__proof-section-title">{translate(text.title)}</h2>
      <div className="secondhand-taxes__proof-section-inner">
        <div className="secondhand-taxes__proof-section-image">
          <div className="u-mobiles-only">
            <Image src={image.src} srcset={image.srcSet} />
          </div>
          <div className="u-desktops-only">
            <Image src={image.srcDesktop} srcset={image.srcSetDesktop} />
          </div>
        </div>
        <div className="secondhand-taxes__proof-section-text">
          <h4 className="secondhand-taxes__proof-section-subtitle">{translate(text.subtitle)}</h4>
          <p
            className="secondhand-taxes__proof-section-description"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: translate(text.description) }}
          />
        </div>
      </div>
    </section>
  )
}

export default ProofSection
